import request from '@/utils/request'

export function getSdk(url, depName) {
  return request({
    url: "https://wx.xchengtech.cn/saas/getJssdk",
    method: 'post',
    data: {
      url: url
    },
    headers: {
      depName: depName,
    },
  })
}

// 更新微信用户信息
export function updateWxInfo(data) {
  return request({
    url: "api/updateWxInfo",
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/wx.js